// follow slice
import { createSlice } from "@reduxjs/toolkit";
import { firestore } from "../../firebase";
import { collection, getDocs, addDoc, serverTimestamp, doc, updateDoc } from "firebase/firestore";

const initialState = {
  follows: [],
  follow: {},
  isLoading: false,
  error: false,
};

export const followSlice = createSlice({
  name: "follow",
  initialState,
  reducers: {
    // START LOADING
    startLoading(state) {
      state.isLoading = true;
    },

    // HAS ERROR
    hasError(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    },

    // GET followS
    getFollowsSuccess(state, action) {
      state.isLoading = false;
      state.follows = action.payload;
    },
    getFollowByIdSuccess(state, action) {
      state.isLoading = false;
      state.follow = action.payload;
    },
    // create follow
    createFollowSuccess(state, action) {
      state.follows.push(action.payload);
    },
    // update follow
    updateFollowSuccess(state, action) {
      state.follows = state.follows.map((follow) => {
        if (follow.id === action.payload.id) {
          return action.payload;
        }
        return follow;
      });
    },
    // delete follow
    deleteFollowSuccess(state, action) {
      const { id } = action.payload;
      state.follows = state.follows.filter((follow) => follow.id !== id);
    },
  },
});

// Action creators are generated for each case reducer function
export const {
  startLoading,
  hasError,
  getFollowsSuccess,
  updateFollowSuccess,
  deleteFollowSuccess,
} = followSlice.actions;

// // Update follow
// export const updateFollow = (data) => async (dispatch) => {
//   const { id, name, WeightUnit } = data;
//   const docRef = doc(firestore, "follow", id);
//   const newData = {
//     name: name,
//     WeightUnit: WeightUnit,
//   };
//   try {
//     dispatch(startLoading());
//     await updateDoc(docRef, newData);
//     dispatch(updateFollowSuccess({ ...newData, id }));
//   } catch (error) {
//     dispatch(hasError(error));
//   }
// };

// get follows from firestore
export const getFollows = () => async (dispatch) => {
  try {
    dispatch(startLoading());
    const querySnapshot = await getDocs(collection(firestore, "follow"));
    const data = querySnapshot.docs.map((doc) => ({
      id: doc.id,
      ...doc.data(),
    }));
    dispatch(getFollowsSuccess(data));
  } catch (error) {
    dispatch(hasError(error));
  }
};
export const getFollowById = (id) => async (dispatch) => {
  try {
    dispatch(startLoading());
    const querySnapshot = await getDocs(collection(firestore, "follow"));
    const data = querySnapshot.docs.map((doc) => ({
      id: doc.id,
      ...doc.data(),
    }));
    dispatch(getFollowsSuccess(data));
  } catch (error) {
    dispatch(hasError(error));
  }
};
export default followSlice.reducer;
